import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";

// import enTranslation from "./locales/en.json";
// import frTranslation from "./locales/ar.json";

// i18n.init({
//   interpolation: { escapeValue: false }, // React already does escaping
//   lng: "ar", // Default language
//   resources: {
//     en: {
//       translation: enTranslation,
//     },
//     ar: {
//       translation: frTranslation,
//     },
//   },
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <I18nextProvider i18n={i18n}> */}
    <App />
    {/* </I18nextProvider> */}
  </>
);
